import React from 'react';
import { Shield, Zap, Star } from 'lucide-react';

const features = [
  { icon: Shield, title: "Secure & Reliable", description: "Advanced protection systems keep you safe" },
  { icon: Zap, title: "Lightning Fast", description: "Optimized for maximum performance" },
  { icon: Star, title: "Features", description: "Access to exclusive functions and capabilities" }
];

export default function Features() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
      {features.map((Feature, index) => (
        <div 
          key={index} 
          style={{ animationDelay: `${index * 0.1}s` }}
          className="relative group animate-fadeIn"
        >
          <div className="relative bg-black/40 backdrop-blur-xl rounded-xl p-8 border border-purple-500/20 hover:border-purple-500/40 transition-all duration-500 hover:transform hover:scale-[1.02] hover:shadow-[0_0_30px_rgba(168,85,247,0.2)]">
            <Feature.icon className="w-12 h-12 text-purple-400 mb-6 transform transition-transform group-hover:scale-110 group-hover:rotate-3" />
            <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-purple-300 transition-colors">
              {Feature.title}
            </h3>
            <p className="text-gray-400 group-hover:text-gray-300 transition-colors">
              {Feature.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}